import api from "./api";

const notificationApi = {
    async getAllNotication() {
        const response = await api.get('/notifications');
        return response.data;
    },
    async markAsRead(ids) {
        try {
            const response = await api.patch('/notifications/mark-read', { ids });
            return response.data;
        } catch (error) {
            console.error('Error marking notifications as read:', error);
            throw error;
        }
        }
    
};


export default notificationApi;